module.exports = __webpack_public_path__ + "omniv2/img/icon-bullbar.97e98544.svg";